module.exports = __webpack_public_path__ + "img/proximidade-icon.196949a9.png";